// extracted by mini-css-extract-plugin
export default {"latestUpdateContainer":"LatestUpdateCell_latestUpdateContainer__yIf3J","baselineRow":"LatestUpdateCell_baselineRow__YMtUq"};